import React from "react";

interface FormData {
  guestName: string;
  guestEmail: string;
  guestPhone: string;
  note: string;
}

interface Props {
  formData: FormData;
  setField: (field: keyof FormData, value: string) => void;
  touched: Record<string, boolean>;
  setTouched: (field: string) => void;
  lang: string;
  t: (key: any) => any;
}

const StepDetails: React.FC<Props> = ({ formData, setField, touched, setTouched, lang, t }) => {
  const nameError = touched.guestName && !formData.guestName.trim() ? t("enterName") : null;
  const phoneError = touched.guestPhone && !formData.guestPhone.trim() ? t("enterPhone") : null;

  return (
    <div className="pab-step">
      <h2 className="pab-step__title">{lang === "en" ? "Your details" : "Vaši podaci"}</h2>
      <div className="pab-step__subtitle">
        {lang === "en" ? "So we can confirm your reservation" : "Da bismo potvrdili vašu rezervaciju"}
      </div>

      <div className="pab-form">
        <div className={`pab-field${nameError ? " pab-field--error" : ""}`}>
          <label className="pab-field__label">
            {lang === "en" ? "First & last name" : "Ime i prezime"} <span className="pab-req">*</span>
          </label>
          <input
            type="text"
            className="pab-input pab-input--lg"
            placeholder={t("namePlaceholder")}
            value={formData.guestName}
            onChange={(e) => setField("guestName", e.target.value)}
            onBlur={() => setTouched("guestName")}
            autoComplete="name"
          />
          {nameError && <div className="pab-field-error">{nameError}</div>}
        </div>

        <div className="pab-field">
          <label className="pab-field__label">{t("email")}</label>
          <input
            type="email"
            className="pab-input pab-input--lg"
            placeholder="ime@mail.com"
            value={formData.guestEmail}
            onChange={(e) => setField("guestEmail", e.target.value)}
            autoComplete="email"
            inputMode="email"
          />
        </div>

        <div className={`pab-field${phoneError ? " pab-field--error" : ""}`}>
          <label className="pab-field__label">
            {lang === "en" ? "Phone" : "Telefon"} <span className="pab-req">*</span>
          </label>
          <input
            type="tel"
            className="pab-input pab-input--lg"
            placeholder="+387 ..."
            value={formData.guestPhone}
            onChange={(e) => setField("guestPhone", e.target.value)}
            onBlur={() => setTouched("guestPhone")}
            autoComplete="tel"
            inputMode="tel"
          />
          {phoneError && <div className="pab-field-error">{phoneError}</div>}
        </div>

        <div className="pab-field">
          <label className="pab-field__label">{t("noteOptional")}</label>
          <textarea
            className="pab-input pab-input--lg pab-textarea"
            placeholder={lang === "en" ? "Special requests, allergies, preferences..." : "Posebne napomene, alergije, preferencije..."}
            value={formData.note}
            onChange={(e) => setField("note", e.target.value)}
            rows={3}
          />
        </div>
      </div>
    </div>
  );
};

export default StepDetails;
